import axios from "axios";
import { useState } from "react";
import { url } from "../utils/config";
import { toast } from "react-toastify";
import Button from "../reusable_components/Button";
import { btnCancel, btnOne, inputStyle, label, modalContainer, modalTitle } from "../utils/style";


function RequestModal(props) {

    const [ requestData, setRequestData ] = useState({});


    function updateRequestData (e) {
        const { name, value} = e.target;
        var data = {...requestData};
        data[name] = value;
        setRequestData(data);
    }

    async function requestTransfer() {
        try {
            if(requestData.equipmentId && requestData.quantity && requestData.note) {
                console.log(requestData);
                const reqUrl = url + '/inventory_transfer';
                const token = window.localStorage.getItem('token');
                const headers = { authorization: `bearer ${token}` };
                const res =  await axios.post(reqUrl, {...requestData, type: props.locationType, from: props.location_id}, { headers });
                console.log(res);
                props.setShowModal(false);
                toast.success(res.data.message, { autoClose: 3000 })
            }
        } catch (error) {
            console.log(error)
            toast.error(error.response.data.message, { autoClose: 3000 })
        }
    }

    return(
        <div className={modalContainer}>
            <div className="bg-white p-4 w-1/2 rounded-lg">
                <div  className={modalTitle}>Request Inventory Transfer</div>
                <div>
                    <div className="grid grid-cols-3 py-2 px-2">
                        <div className={label}>Select Equipment</div>
                        <div className="col-span-2">
                            <select className={inputStyle} name="equipmentId" value={requestData.equipmentId} onChange={e => updateRequestData(e)}>
                                {
                                    props.equipments.map((se, i) => <option key={i} value={se.id}>{se.name}</option>)
                                }
                            </select>
                        </div>
                    </div>
                    <div className="grid grid-cols-3 py-2 px-2">
                        <div className={label}>Enter Quantity</div>
                        <div className="col-span-2">
                            <input className={inputStyle} type="number" name='quantity' value={requestData.quantity} onChange={e => updateRequestData(e)}/>
                        </div>
                    </div>
                    <div className="grid grid-cols-3 py-2 px-2">
                        <div className={label}> Transfer Note</div>
                        <div className="col-span-2">
                            <textarea className={inputStyle} name='note' value={requestData.note} onChange={e => updateRequestData(e)}/>
                        </div>
                    </div>
                </div>
                <div className="flex justify-between py-3 px-16 gap-8">
                    <button onClick={() => props.setShowModal(false)} className={btnCancel}>Cancel</button>
                    <Button clickHandler={() => requestTransfer()} className={btnOne} name={'Submit'} />
                </div>
            </div>
        </div>
    )
}

export default RequestModal;